var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"social-auth-btn",attrs:{"outlined":""},on:{"click":_vm.social_login}},[_c('img',{attrs:{"src":_vm.btn_icon,"alt":_vm.btn_text}}),_c('p',{staticClass:"mb-0 ms-3 btn-text"},[_vm._v(_vm._s(_vm.btn_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }